import { render } from "./UpdateUserProfile.vue?vue&type=template&id=739e54e0&scoped=true"
import script from "./UpdateUserProfile.vue?vue&type=script&lang=js"
export * from "./UpdateUserProfile.vue?vue&type=script&lang=js"

import "./UpdateUserProfile.vue?vue&type=style&index=0&id=739e54e0&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-739e54e0"]])

export default __exports__